<template>
    <div>
        <v-list-item @click.stop="dialog = true">
            <v-list-item-title>Cancel</v-list-item-title>
        </v-list-item>
        <v-dialog width="700px" v-model="dialog">
            <v-card v-if="dialog">
                <v-card-title>
                    <span class="headline">Cancel Shift, {{period_date | formatDate}}</span>
                    <div class="dialog-closeBtn" @click="dialog = false"><v-icon left>mdi-close</v-icon></div>
                </v-card-title>
                <v-card-text class="dialog-card_body">
                    <v-row align="stretch">
                        <!-- left panel -->
                        <v-col xs="12" sm="3" md="3">
                            <v-row>
                                <v-col xs="12" sm="12" md="12">
                                    Driver info
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-list nav dense class="col">
                                    <v-list-item>
                                        <v-list-item-icon>
                                        <v-icon>mdi-calendar</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-content>
                                        <v-list-item-title>__</v-list-item-title>
                                        <v-list-item-subtitle>Weekly Hours</v-list-item-subtitle>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                                <v-list nav dense>
                                    <v-list-item>
                                        <v-list-item-icon>
                                        <v-icon>mdi-currency-gbp</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-content>
                                        <v-list-item-title>___£</v-list-item-title>
                                        <v-list-item-subtitle>Weekly Cost</v-list-item-subtitle>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                                <v-list nav dense>
                                    <v-list-item>
                                        <v-list-item-icon>
                                        <v-icon>mdi-clock-outline</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-content>
                                        <v-list-item-title>{{shiftLength}}</v-list-item-title>
                                        <v-list-item-subtitle>Shift Length</v-list-item-subtitle>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                                <v-list nav dense>
                                    <v-list-item>
                                        <v-list-item-icon>
                                        <v-icon>mdi-account</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-content>
                                        <v-list-item-title>£{{shiftCost}}</v-list-item-title>
                                        <v-list-item-subtitle>Shift Cost</v-list-item-subtitle>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                            </v-row>
                            <v-row>
                                <v-col class="pl-0 pr-0">
                                    <v-divider></v-divider>
                                    <v-row no-gutters>
                                        <v-col v-if="creator" cols="12" sm="12" md="12">
                                            Shift Creator: #{{creator.id}} {{creator.full_name}} ({{creator.email}})
                                        </v-col>
                                        <v-col v-if="moderator" cols="12" sm="12" md="12">
                                            Shift Moderator: #{{moderator.id}} {{moderator.full_name}} ({{moderator.email}})
                                        </v-col>
                                        <v-col v-if="restaurateur_creator" cols="12" sm="12" md="12">
                                            Shift Creator: #{{restaurateur_creator.id}} {{restaurateur_creator.name}} ({{restaurateur_creator.email}})
                                        </v-col>
                                        <v-col v-if="restaurateur_moderator" cols="12" sm="12" md="12">
                                            Shift Moderator: #{{restaurateur_moderator.id}} {{restaurateur_moderator.name}} ({{restaurateur_moderator.email}})
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col xs="12" sm="9" md="9">
                            <v-form ref="form">
                                <v-row>
                                    <v-col cols="12" sm="12" md="12">
                                        <i v-if="driver_rejected_id" class="blue lighten-4"><v-icon style="font-size: 14px; color: #2196F3;">mdi-information-outline</v-icon> Shift rejected by {{getDriverFullName(driver_rejected_id)}}</i>
                                        <v-autocomplete
                                            label="Select driver"
                                            item-text="full_name"
                                            item-value="id"
                                            v-model="driver_id"
                                            :items="driverListSearched"
                                            @input="$v.driver_id.$touch()"
                                            @blur="$v.driver_id.$touch()"
                                            required
                                            dense
                                            solo
                                        >
                                        </v-autocomplete>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6">
                                        <v-text-field
                                            type="number"
                                            prepend-icon="mdi-wallet-giftcard"
                                            label="Cancellation fee/bonus"
                                            hint="hidden for restaurants"
                                            v-model="cost"
                                            @change='validateNegative'
                                            placeholder="Enter a negative number"
                                            required
                                            outlined
                                            dense
                                        >
                                        </v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="12" class="pb-0">
                                        <v-textarea
                                            outlined
                                            label="Comment"
                                            v-model="comment_cancelled"
                                        ></v-textarea>
                                    </v-col>
                                </v-row>
                                <div class="d-flex justify-center">
                                    <v-btn
                                            depressed
                                            class="mr-4 primary"
                                            :disabled="this.$v.$invalid || localLoading"
                                            :loading="localLoading"
                                            @click="submit"
                                    ><v-icon left>mdi-upload</v-icon>Save</v-btn>
                                    <v-btn
                                            class="mr-4"
                                            :loading="localLoading"
                                            depressed
                                            @click="clear"
                                    ><v-icon left>mdi-rotate-left</v-icon>Restore</v-btn>
                                    <v-btn
                                            class="mr-4 warning"
                                            :loading="localLoading"
                                            depressed
                                            @click="dialog=false"
                                    ><v-icon left>mdi-cancel</v-icon>Cancel</v-btn>
                                </div>
                            </v-form>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required,/* maxLength, email, numeric */ } from 'vuelidate/lib/validators'
import { mapGetters } from 'vuex';
import moment from 'moment';
import * as _ from 'lodash';
import { /*STATUS_NEW,*/ STATUS_ASSIGNED, STATUS_FREE, STATUS_STALE } from '../../store/shifts';
import {  STATUS_APPROVED,STATUS_PROGRESS_PAY_APPROVED
       } from '../../store/timesheets';
const IS_HOLIDAY = 10;
// const IS_REGULAR_DAY = 20;
const INSERTED = 10;
const UPDATED = 20;
const DELETED = 30;
const CANCELLED = 40;

const MODEL_TYPE_SHIFTS = 10;

export default {
    mixins: [validationMixin],
    name: "CancelShiftModal",
    props: ['shiftItem', 'shiftList'],
    validations: {
        driver_id: { required },
        start_time: { required },
        finish_time: { required },
        comment_cancelled: { }
    },
    data: () => ({
        readOnly: false,
        localLoading: false,
        dialog: false,
        // --
        driver_id: 0,
        driver_rejected_id: 0,
        status: '',
        status_assigned: '',
        period_date: '',
        start_time: '',
        finish_time: '',
        cost_per_hour: '',
        cost_total: '',
        cost_bonus: 0,
        const_fuel_bonus: 0,
        cost_extra_bonus: 0,
        cost: '',
        comment_cancelled: '',
        // --
        restaurant_selected: void 0,
        area_selected: void 0,
        is_initialized: false,
    }),
    updated() {
        if (this.$data.dialog && !this.$data.is_initialized) {
            this.$data.restaurant_selected = _.find(this.restaurants, p => {
                return p.id == this.$props.shiftItem.restaurant_id;
            });

            this.$data.area_selected = _.find(this.areas, p => {
                return p.id == this.$data.restaurant_selected.area_id;
            });

            if (this.$props.shiftItem.status_assigned == STATUS_STALE) {
                this.$data.driver_id = 0;
                this.driver_rejected_id = +this.$props.shiftItem.driver_id;
            } else {
                this.$data.driver_id = !this.$props.shiftItem.driver_id ? 0 : +this.$props.shiftItem.driver_id; // "driver_id === null" become 0
            }

            this.$data.status = this.$props.shiftItem.status;
            this.$data.status_assigned = this.$props.shiftItem.status_assigned;
            this.$data.period_date = this.$props.shiftItem.period_date;
            this.$data.start_time = this.$props.shiftItem.start_time.substr(0, 5); // format time from HH:mm:ss to HH:mm
            this.$data.finish_time = this.$props.shiftItem.finish_time.substr(0, 5); // format time from HH:mm:ss to HH:mm
            this.$data.cost_per_hour = this.$props.shiftItem.cost_per_hour;
            this.$data.cost_total = this.$props.shiftItem.cost_total;
            this.$data.cost_bonus = +this.$props.shiftItem.cost_bonus;
            this.$data.const_fuel_bonus = +this.$props.shiftItem.const_fuel_bonus;
            this.$data.cost_extra_bonus = +this.$props.shiftItem.cost_extra_bonus;
            //this.$data.comment = this.$props.shiftItem.comment;

            this.$data.is_initialized = true;

        }
    },
    computed: {
        ...mapGetters(['areas', 'restaurants', 'restaurateurs']),
        ...mapGetters("user", {
            users: "users",
        }),
        driver_list() {
            return this.$store.getters.drivers;
        },
        creator() {
            return _.find(this.users, p => p.id == this.$props.shiftItem.creator_id);
        },
        moderator() {
            return _.find(this.users, p => p.id == this.$props.shiftItem.moderator_id);
        },
        restaurateur_creator() {
            return _.find(this.restaurateurs, p => p.id == this.$props.shiftItem.restaurateur_creator_id);
        },
        restaurateur_moderator() {
            return _.find(this.restaurateurs, p => p.id == this.$props.shiftItem.restaurateur_moderator_id);
        },
        driverListSearched() {
            let restaurant = _.find(this.restaurants, p => p.id == this.$props.shiftItem.restaurant_id)
            let drivers = _.filter(this.driver_list, driver => {
                if (driver.area_ids.length == 0) {
                    return true; // driver not assigned to any area
                }

                let driver_area_ids = _.map(driver.area_ids, p => p.area_id);
                if (driver_area_ids.indexOf(restaurant.area_id) === -1) {
                    return false;
                }

                // check driver assigned to restaurant
                if (driver.restaurant_ids.length == 0) {
                    return true; // driver not assigned to any restaurant
                }

                let driver_restaurant_item = _.find(driver.restaurant_ids, p => p.restaurant_id == restaurant.id);
                if (driver_restaurant_item) {
                    return true;
                }

                return false;
            });

            let free_driver = {
                id: 0,
                full_name: "Open shift",
            };

            drivers.unshift(free_driver);
            return drivers;
        },
        selectedDriverWorkingDay() {
                let driver = _.find(this.driver_list, p => p.id == this.$data.driver_id);
                if (!driver) {
                    return [];
                }

                // try to find override dates
                let items = _.filter(driver.actual_override_working_time, p => p.period_date == this.$data.period_date);
                if (items.length > 0) {
                    return items;
                }

                // try to find deafult weekday schedule
                let week_day = moment(this.$data.period_date, "YYYY-MM-DD").isoWeekday() - 1;
                items = _.filter(driver.default_working_time, p => p.week_day == week_day);

                return items;
            },
            shiftLength: function() {
                let finish_time = moment(this.$data.finish_time, "HH:mm");
                let start_time = moment(this.$data.start_time, "HH:mm");
                if (!finish_time.isValid() || !start_time.isValid()) {
                    return 0;
                }

                if (this.$data.finish_time < this.$data.start_time) {
                    finish_time.add(1, 'days');
                }

                let total_time_hours = ( (finish_time - start_time) / (60 * 1000) ) / 60;

                return total_time_hours.toFixed(2); // round
            },
            shiftCostPerHour: function() {
                if (!this.$data.area_selected || !this.$data.restaurant_selected) {
                    return 0;
                }

                let cost_per_hour = this.$data.restaurant_selected.standard_pay ? this.$data.restaurant_selected.standard_pay : this.$data.area_selected.standardPayRate;
                // check date is weekend, then get weekend rate
                let shift_date = moment(this.$data.period_date, "YYYY-MM-DD");
                if(shift_date.isoWeekday() === 5 || shift_date.isoWeekday() === 6 || shift_date.isoWeekday() === 7) {
                    cost_per_hour = this.$data.restaurant_selected.weekend_pay ? this.$data.restaurant_selected.weekend_pay : this.$data.area_selected.weekendPayRate;
                }

                return cost_per_hour;
            },
            shiftCost: function() {
                return ((+this.shiftCostPerHour * this.shiftLength) + +this.cost_bonus + +this.const_fuel_bonus).toFixed(2);
            },
        },

    methods: {
        submit () {
            this.localLoading = true;
            this.$v.$touch();
            if (!this.$v.$invalid) {
                this.$data.cost_per_hour = this.shiftCostPerHour;
                this.$data.cost_total = this.shiftCost;

                const shift_data = {
                    id: this.$props.shiftItem.id,
                    restaurant_id: this.$props.shiftItem.restaurant_id,
                    driver_id: 0,
                    driver_id_canceled: this.$props.shiftItem.driver_id,
                    status: this.$data.status,
                    status_assigned: STATUS_STALE,
                    period_date: this.$data.period_date,
                    start_time: this.$data.start_time,
                    finish_time: this.$data.finish_time,
                    shift_id: this.$data.shift_id,
                    meal_time: 0,
                    rest_time: 0,
                    cost_per_hour: this.$data.cost_per_hour,
                    cost_total: this.$data.cost_total,
                    cost_bonus: this.$data.cost_bonus,
                    const_fuel_bonus: this.$data.const_fuel_bonus,
                    cost_extra_bonus: this.$data.cost_extra_bonus,
                    cost: this.$data.cost,
                    comment_cancelled: this.$data.comment_cancelled,
                    model_type: MODEL_TYPE_SHIFTS,
                    event: CANCELLED,
                    model_id: this.$props.shiftItem.id
                }
                let timesheet_data = {
                    id: this.$props.shiftItem.id,
                    restaurant_id: this.$props.shiftItem.restaurant_id,
                    driver_id: this.$props.shiftItem.driver_id,
                    status: STATUS_APPROVED,
                    status_progress: STATUS_PROGRESS_PAY_APPROVED,
                    period_date: this.$data.period_date,
                    start_time: this.$data.start_time,
                    finish_time: this.$data.start_time,
                    shift_id: 0, //this.$data.shift_id,
                    meal_time: 0,
                    rest_time: 0,
                    cost_per_hour: 0,
                    cost_total: 0,
                    cost_bonus: this.$data.cost_bonus,
                    const_fuel_bonus: 0,
                    cost_extra_bonus: this.$data.cost,
                    fuel_bonus_6: 0,
                    fuel_bonus_3: 0,
                    fuel_bonus_0: 0,
                    comment: this.$props.shiftItem.id+':'+this.$data.comment_cancelled,
                    modified_shift_id: this.$props.shiftItem.id,
                }
                if (shift_data.driver_id == 0) { // fix 0 to null
                    shift_data.driver_id = null;
                }

                this.$store.dispatch('editShift', shift_data);
                this.$store.dispatch('cancelShift', shift_data).then(() => {
                    this.dialog = false;
                    this.is_initialized = false;
                    this.$store.dispatch('createNewTimesheet', timesheet_data);
                }).finally(() => {
                    this.localLoading = false;
                });
            }
        },
        clear () {
            this.$v.$reset();
            this.$data.restaurant_id = this.$props.shiftItem.restaurant_id;

            if (this.$props.shiftItem.status_assigned == STATUS_STALE) {
                this.$data.driver_id = 0;
                this.driver_rejected_id = +this.$props.shiftItem.driver_id;
            } else {
                this.$data.driver_id = !this.$props.shiftItem.driver_id ? 0 : +this.$props.shiftItem.driver_id; // "driver_id === null" become 0
            }

            this.$data.status = this.$props.shiftItem.status,
            this.$data.status_assigned = this.$props.shiftItem.status_assigned,
            this.$data.period_date = this.$props.shiftItem.period_date;
            this.$data.start_time = this.$props.shiftItem.start_time.substr(0, 5); // format time from HH:mm:ss to HH:mm
            this.$data.finish_time = this.$props.shiftItem.finish_time.substr(0, 5); // format time from HH:mm:ss to HH:mm
            this.$data.cost = 0;
            this.$data.comment_cancelled = '';
        },
        isTimeIntersects(start_at, stop_at, check) {
            if (!check) {
                return false;
            }

            if (moment(start_at, "HH:mm").format('HH:mm') < moment(stop_at, "HH:mm").format('HH:mm')) {
                return moment(start_at, "HH:mm").format('HH:mm') <= moment(check, "HH:mm").format('HH:mm')
                    && moment(stop_at, "HH:mm").format('HH:mm') >= moment(check, "HH:mm").format('HH:mm');
            } else {
                return moment(start_at, "HH:mm").format('HH:mm') <= moment(check, "HH:mm").format('HH:mm');
            }
        },
        getDriverFullName: function(driver_id) {
            let driver = _.find(this.driver_list, p => p.id == driver_id);
            if (!driver) {
                return '-';
            }

            return driver.full_name;
        },
        validateNegative(value) {
            if (value >= 0) {
                // If the value is non-negative, set it to an empty string or a valid negative value
                //const value = parseFloat(this.event.target.value);  // Convert to a number
                this.$v.$reset();
                this.cost = 0;
            } else {
                // Otherwise, accept the negative value
                this.cost = value;
            }
        }
    },
    filters: {
      formatDate: function (date) {
        return moment(date, "YYYY-MM-DD").format('MMM Do');
      },
    },
}
</script>